/*
 * This file contains helper methods for working with Google Tag Manager (GTM),
 * such as pushing events to the GTM dataLayer to use as triggers etc
 *
 * GTM UI: https://tagmanager.google.com
 * Admins: Adam, Danny and Jane
 *
 * Note:
 * Some institutions load their own GTM container as well as the default OL container
 * Superusers can manage an institution's Google Tag Manager code via the institution admin > advanced page
 *
 * Where is the GTM snippet added?
 * - OpenLearningEngine/openlearning/engine/templates/engine/newBase.html
 * - OpenLearningEngine/openlearning/portal/templates/portal.html
 *
 */
export const GTM = {
  pushEvent(event, eventData) {
    /*
     * Requires the GTM snippet to have been loaded on the page
     */
    if (window.dataLayer) {
      window.dataLayer.push({ event, ...(eventData || {}) });
    }
  },
};
